import { ReactElement } from "react";
import { TooltipWrapper } from "../styles";

interface TooltipButtonProps {
  label?: number;
  tooltip: string;
  color?: string;
  children?: ReactElement;
  className?: string;
}

const TOTAL = 62;

export const TooltipButtonDetails = ({
  label,
  tooltip,
  color = "transparent",
  children,
  className = "",
}: TooltipButtonProps) => {
  let width = 0;

  if (label) {
    width = (label / TOTAL) * 100;
  }

  return (
    <TooltipWrapper color={color} width={width} className={className}>
      {children}
      <span>{tooltip}</span>
    </TooltipWrapper>
  );
};
